import { Button, Form, Input, message } from "antd";
import { Encrypt } from "@/utils/crypto";
import "./index.less";
import { serviceApi } from "@/apis";
import { useNavigate } from "react-router";
import { useUserInfoDispath } from "@/model";

const validcheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,16}$/;
const logo2 = require("@/images/yd2.png");
const logo3 = require("@/images/yd3.png");
const logo4 = require("@/images/yd4.png");

type FieldType = {
  originalPassword?: string;
  newPassword?: string;
  confirmPassword?: string;
};


const Reset = () => {
  const dispatch = useUserInfoDispath();
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/home");
  };

  const onFinish = (values: FieldType) => {
    serviceApi
      .updatePasswordInLoginStatus({
        originalPassword: Encrypt(values.originalPassword || ""),
        newPassword: Encrypt(values.newPassword || ""),
        confirmPassword: Encrypt(values.confirmPassword || ""),
      })
      .then(() => {
        message.success("更改密码成功，请重新登录");
        dispatch({
          type: "luser/clearTempJwt",
        });
        navigate("/home");
        setTimeout(() => {
          
          dispatch({
            type: "login/open",
          });
        }, 1000);
      })
      .catch((err) => {
        message.error(err);
      });
    };

  return (
    <>
    <article className="nav-bar-reset flex shop-pc max-width">
      <div className="logo flex-b-c" onClick={goHome}>
        <div className="logo-Word">
          <img src={logo3} alt="" />
          <img src={logo4} alt="" />
        </div>
        <img src={logo2} alt="" />
      </div>
      
    </article>
    <div style={{width: "100%", backgroundColor: "#fff"}}>
      <h3 className="reset-nav-title">重置密码</h3>
    </div>
      
      <article className="reset-main">
        <div className="reset-content">
          <div className="reset-form">
            <Form
              name="basic"
              labelCol={{ span: 6 }}
              // wrapperCol={{ span: 16 }}
              style={{ maxWidth: 400 }}
              onFinish={onFinish}
              // onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item<FieldType>
                label="当前密码"
                name="originalPassword"
                className="uppassword-form-item"
                rules={[{ required: true, message: "当前密码不能为空!" }]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item<FieldType>
                label="更改密码"
                name="newPassword"
                className="uppassword-form-item"
                rules={[
                  { required: true, message: "请输入密码!" },
                  {
                    pattern: validcheck,
                    message:
                      "密码必须包含大小写字母、数字、特殊字符，长度8-16位",
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                label="确认密码"
                className="uppassword-form-item"
                dependencies={["newPassword"]}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "请再次输入密码!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("newPassword") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("两次输入密码不一致!"));
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item
                className="uppassword-form-btn"
                wrapperCol={{ offset: 6, span: 16 }}
                style={{ marginTop: 30 }}
              >
                <Button type="primary" htmlType="submit">
                  确认修改
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </article>
    </>
  );
};

export default Reset;
